import * as utility from "../services"
import * as common_components from "../editor_common_components"
import * as react_components from "../reactcomponent"
import * as propertyTypes from "../property_types"
import * as hierarchical from "./hierarchical_datasource_builder"
import { SqlParameter, SqlParameterState } from "./api_builder_common"
import { Innosoft_InnoBI_Controllers_ApiBuilderController as ApiBuilderController, Innosoft_InnoBI_IWebservice as IWebservice } from "../generated_api/generated_api"
import { UiBuildertoolBar } from "../components/ui_builder_toolbar"
import { SavingDialog } from "../components/saving_dialog"
import { getGlobalSettings } from "../settings"
import { DropDownList } from "../components/drop_down_list"
import { registerComponents } from "../statistic_ui"
import { NotificationHelper } from "../../core/util/notificationHelper"
import { Menu, EntryType } from "../../core/components/menu"
import { General } from "../../../siteManagement/general"
import React from "react"

export { registerComponents };

var Inno = Inno || {};

var sqlServiceEditor = {
    "rows": [
        {
            "type": "ROW", "rowItems": [
                { type: "CODEEDITOR", name: "GetQuery", header: "SQL-Service" }]
        }
    ]
};

export class ApiBuilderState extends propertyTypes.Serializable {
    private translateValuesMetadata = new propertyTypes.CheckBoxProperty("translateValues", "Translate values");
    public TranslateValues: boolean;

    private ParametersMetadata = new propertyTypes.ObjectListPropertyExt("Parameters", "Parameters").addStateImplementation("default", SqlParameterState);
    public Parameters: string;

    getMetadata(): propertyTypes.BaseProperty[] {
        return [this.ParametersMetadata, this.translateValuesMetadata];
    }
}

export class ApiBuilder extends React.Component<any, any>{
    constructor(props) {
        super(props);
        this.state = { uiValues: {}, selectedService: null }
    }


    render() {

        return (<div>
            <EditorView api={this.props.match.params.api} />
        </div>
        );
    }
};

class EditorView extends React.Component<any, any>{
    apiBuilderController: ApiBuilderController;

    constructor(props) {
        super(props);
        this.state = { type: -1 };
        this.apiBuilderController = new ApiBuilderController();
    }

    componentDidMount() {
        this.getUi(this.props.api);
    }

    getUi(id) {
        this.apiBuilderController.GetServiceConfig(id, (result) => {
            this.setState({ type: result.Type, ui: result.Config, id: id, serviceName: result.ServiceName, isInternal: result.IsInternal });
            General.Sheet.Manager.getTopMostSheet().setTitle(result.ServiceName);
        });
    }
    render() {
        var serviceEditor;

        if (this.state.type === 0) {
            serviceEditor = <SqlServiceEditor key={this.state.id} uiValues={this.state.ui} id={this.state.id} name={this.state.serviceName} isInternal={this.state.isInternal} />;
        }
        else if (this.state.type === 1) {
            serviceEditor = <hierarchical.HierarchicalServiceEditor uiValues={this.state.ui} key={this.state.id} id={this.state.id} name={this.state.serviceName} isInternal={this.state.isInternal} />;
        }
        else if (this.state.type === 2) {
            serviceEditor = <AssemblyServiceEditor key={this.state.id} uiValues={this.state.ui} id={this.state.id} isInternal={this.state.isInternal} />;
        }

        else {
            serviceEditor = <div>....</div>
        }
        return (serviceEditor);
    }
};

class SqlServiceEditor extends React.Component<any, any>{
    private apiBuilderState: ApiBuilderState;
    private apiBuilderController: ApiBuilderController;
    private executeSql;
    private menuEntries;

    constructor(props) {
        super(props);
        this.state = { uiValues: props.uiValues, isSaving: false };
        this.apiBuilderState = new ApiBuilderState();
        this.apiBuilderState.hydrateFromJS(props.uiValues);
        this.apiBuilderController = new ApiBuilderController();
        this.menuEntries = [{ type: EntryType.Save, onClick: this.handleClick, show: this.canSaveApi() }, { text: "Execute SQL", onClick: this.handleExecuteSQL }];
    }

    handleTextChange = (name, value) => {
        this.state.uiValues[name] = value;
        this.setState({ uiValues: this.state.uiValues, hasChanges: true });
    }

    routerWillLeave() {
        if (this.state.hasChanges && this.canSaveApi()) {
            return "Discard changes?";
        }
    }

    handleArrayChanged(propertyName, newArray) {
        var newState = Object.assign({}, this.state.uiValues);
        newState[propertyName] = newArray;
        this.setState({ uiValues: newState });
    }

    handleSettingsChanged = (newSettings) => {
        this.apiBuilderState.hydrateFromJS(newSettings);
        this.setState({ uiValues: newSettings });
    }

    handleSave = () => {
        this.apiBuilderController.Save(this.props.id, this.state.uiValues, (result) => {
            NotificationHelper.showSuccessMessage("Saved successfully");
        });
        this.setState({ isSaving: true });
    }

    canSaveApi = () => {
        if (getGlobalSettings().GetSettings().INNO_IS_INTERNAL_USER == 1) {
            return true;
        }
        else if (this.props.isInternal == 1) {
            return false;
        }
        return true;
    }

    showWarningIfCantSave = () => {
        if (!this.canSaveApi()) {
            return <div style={{ backgroundColor: "red" }}>This is an internal api. Changes can not be saved. Please create a copy.</div>
        }
    }

    handleEval = () => {

    }

    handleClick = (mouseButton) => {
        this.apiBuilderController.Save(this.props.id, this.state.uiValues, (result) => {
            NotificationHelper.showSuccessMessage("Saved successfully");
        });
        this.setState({ isSaving: true });
    }

    handleExecuteSQL = () => {
        this.executeSql();
    }

    render() {
        var editorForElement = this.apiBuilderState.getMetadata();
        var ui = sqlServiceEditor;
        return (<>
            <div className="dashboardContent" style={{ left: "0px" }}>
                {this.showWarningIfCantSave()}
                <react_components.ReactDynamicUi uiDefinition={ui}
                    onTextChange={this.handleTextChange}
                    parameters={this.state.uiValues} />
                <Menu entries={this.menuEntries} onSelect={this.handleEval} enableMenuItem={() => true} handleEval={this.handleEval} />
                <SqlExecutor serviceDefinition={this.state.uiValues} onInitExecuteSql={(exec) => this.executeSql = exec} />
            </div>

            <div className="rightSidebar">
                <react_components.SideBar header="PROPERTIES">
                    <ul className="list-group">
                        <common_components.PropertiesEditor key={this.state.selectedElement}
                            componentState={this.apiBuilderState}
                            properties={editorForElement}
                            selectedElement={this.state.uiValues}
                            onSettingsChanged={this.handleSettingsChanged}></common_components.PropertiesEditor>
                    </ul>
                </react_components.SideBar>
            </div>
        </>
        );
    }
};

class AssemblyServiceEditor extends React.Component<any, any>{
    private apiBuilderController: ApiBuilderController;
    private menuEntries;

    constructor(props) {
        super(props);
        this.state = { uiValues: props.uiValues };
        this.apiBuilderController = new ApiBuilderController();
        this.apiBuilderController.GetAvailableAssemblyServices((assemblies) => {
            this.setState({ assemblies: assemblies });
        });
        this.menuEntries = [{ type: EntryType.Save, onClick: this.handleSave, show: this.canSaveApi() }];
    }

    handleValueChange = (value) => {
        this.state.uiValues["ServiceId"] = value;
        this.setState({ uiValues: this.state.uiValues });
    }

    handleChanges = (object, propertyName, value) => {
        object[propertyName] = value;
        this.forceUpdate();
    }

    handleArrayChanged = (propertyName, newArray) => {
        var newState = Object.assign({}, this.state.uiValues);
        newState[propertyName] = newArray;
        this.setState({ uiValues: newState });
    }

    canSaveApi = () => {
        if (getGlobalSettings().GetSettings().INNO_IS_INTERNAL_USER == 1) {
            return true;
        }
        else if (this.props.isInternal == 1) {
            return false;
        }
        return true;
    }

    showMenuOrWarning = () => {
        if (!this.canSaveApi()) {
            return <div style={{ backgroundColor: "red" }}>This is an internal api. Changes can not be saved. Please create a copy.</div>
        }
    }

    showParameters = () => {
        const ass: IWebservice[] = this.state.assemblies;
        const id = this.props.uiValues["ServiceId"];
        if (id && ass) {
            const service = ass
                .filter((value, index) => { return value.ServiceId == id });

            if (service && service.length > 0 && service[0].Parameter) {
                return service[0].Parameter.map((p) => {
                    return (
                        <div>
                            <div>Parameter: {p.ParameterName}</div>
                            <div>Description: {p.Description}</div>
                            <div>Is mandatory: {p.IsMandatory}</div>
                        </div>)
                })
            }
        }
    }

    handleSave = () => {
        this.apiBuilderController.Save(this.props.id, this.state.uiValues, (result) => NotificationHelper.showSuccessMessage("Saved successfully"));
    }
    handleEval = () => { }
    render() {
        return (<div>
            <Menu entries={this.menuEntries} onSelect={this.handleEval} enableMenuItem={() => true} handleEval={this.handleEval} />
            {this.showMenuOrWarning()}
            {this.showParameters()}
            <DropDownList keyField="ServiceId" valueField="ServiceName" value={this.props.uiValues["ServiceId"]} onChange={this.handleValueChange} data={this.state.assemblies} />
        </div>
        );
    }
};

interface SqlExecutorState {
    data?
    uiState?
    elapsedMillisecondsSql?
    elapsedMillisecondsHttp?
    errorMessage?
    parameterValues?
}

class SqlExecutor extends React.Component<any, SqlExecutorState>{
    apiBuilderController: ApiBuilderController;
    constructor(props) {
        super(props);
        this.state = {};
        this.apiBuilderController = new ApiBuilderController();
        if (this.props.onInitExecuteSql) {
            this.props.onInitExecuteSql(this.handleExecuteSql);
        }
    }

    handleExecuteSql = () => {
        this.setState({ uiState: "loading" });
        const httpStart = "httpStart";
        const httpEnd = "httpEnd";
        const httpMeasure = "httpDiv";
        performance.mark(httpStart);
        this.apiBuilderController.ExecuteSql({ serviceDefinition: this.props.serviceDefinition, parameters: this.state.parameterValues }, (result) => {
            if (result.state == "success") {
                performance.mark(httpEnd);
                performance.measure(httpMeasure, httpStart, httpEnd);
                const durationMilliseconds = performance.getEntriesByName(httpMeasure)[0].duration
                this.setState({ data: result.data, uiState: "loaded", elapsedMillisecondsSql: result.elapsedMilliseconds, elapsedMillisecondsHttp: durationMilliseconds });
            }
            else {
                this.setState({ uiState: "failure", errorMessage: result.errorMessage });
            }
            performance.clearMarks();
            performance.clearMeasures();
        });
    }

    handleParametersChanged = (name, value) => {
        var params = this.state.parameterValues || {};
        params[name] = value;
        this.setState({ parameterValues: params });
    }

    render() {
        var resultView = null;
        if (this.state.uiState == "loading") {
            resultView = <div>loading...</div>
        }
        else if (this.state.uiState == "loaded") {
            resultView = <SqlResultTable data={this.state.data} elapsedMillisecondsSql={this.state.elapsedMillisecondsSql} elapsedMillisecondsHttp={this.state.elapsedMillisecondsHttp} />;
        }
        else if (this.state.uiState == "failure") {
            resultView = <div style={{ "backgroundColor": "white", "whiteSpace": "pre" }}>{this.state.errorMessage}</div>
        }
        return (
            <div>
                <SqlParameter parameters={this.props.serviceDefinition.Parameters} parameterValues={this.state.parameterValues} onTextChange={this.handleParametersChanged} />
                {resultView}
            </div>)
    }
};

class SqlResultTable extends React.Component<{ data: any[], elapsedMillisecondsSql: number, elapsedMillisecondsHttp: number }, any>{
    private gridRef: any;
    private grid: any;
    constructor(props) {
        super(props);
        this.state = { page: 0 }
    }

    componentDidMount() {
        this.createGrid(this.props.data);
    }

    generateColumns = (data: any[]) => {
        let columns: any[] = [];
        if (data && data.length > 0) {
            for (var key in data[0]) {
                columns.push({ field: utility.generateColumnName(key), title: key, width: 150 });
            }
        }
        return columns;
    }

    createGrid = (data) => {
        data = data || [];
        var that = this;
        var $rootNode = $(this.gridRef);
        let columns = this.generateColumns(data);

        const gridConfig: any = {
            dataSource: {
                data: data,
                pageSize: 20
            },
            resizable: true,
            height: 550,
            sortable: true,
            pageable: {
                refresh: false,
                pageSizes: true,
                buttonCount: 5
            },
            columns: columns
        };

        if (data && data[0]) {
            let fields: any = {};
            for (let key in data[0]) {
                const hashCode = utility.generateColumnName(key);
                fields[hashCode] = { from: `["${key}"]` };
            }
            gridConfig.dataSource.schema = { model: { fields: fields } };
        }
        var grid = $rootNode.kendoGrid(gridConfig);
        this.grid = grid.data("kendoGrid");
    }

    componentDidUpdate(prevProps, prevState) {
    }

    componentWillUnmount() {
        this.grid.destroy();
    }

    render() {
        var style = { width: "100%" };
        return (<div className="col-sm-12" style={{ padding: "0px" }}>
            {`Max 1000 results. Elapsed seconds SQL ${Math.round((this.props.elapsedMillisecondsSql)) / 1000}. Elapsed seconds SQL + HTTP ${Math.round((this.props.elapsedMillisecondsHttp)) / 1000}`}
            <div ref={(e) => this.gridRef = e}></div>
        </div>)
    }
};
